import React from "react";
import PropTypes from "prop-types";
import { TogglerStyle, TogglerIconStyle } from "./toggler.style";

const Toggler = ({
  children,
  innerRef,
  ...attributes
}) => {
  return (
    <TogglerStyle {...attributes} ref={innerRef}>
      {children || <TogglerIconStyle/>}
    </TogglerStyle>
  );
};

Toggler.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  inHeader: PropTypes.bool,
  inNavbar: PropTypes.bool,
};

Toggler.defaultProps = {
  inHeader: false,
  inNavbar: false,
};

export default Toggler;
